import React from 'react';
import Styles from 'src/components/Styles';
import {Dimensions, Platform, StyleSheet, Pressable, View} from 'react-native';
import AVText from 'src/components/elements/AVText';
import Localized from 'src/constants/AppStrings';
import TagIcon from 'src/components/img/svg/TagIcon';
import NavActions from 'src/actions/NavActions';
import AppRoutes from 'src/AppRoutes';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';

const width = Dimensions.get('window').width;

const OffersView = () => {
  return (
    <View style={styles.container}>
      <View style={styles.iconView}>
        <TagIcon size={Styles.Heights.h3} color={Styles.darkGreenRevolve} />
      </View>
      <View style={styles.offerTextView}>
        <AVText
          style={styles.offerText}
          numberOfLines={1}
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm4}
        >
          {Localized.Labels.offers}
        </AVText>
      </View>
      <View
        style={{
          alignSelf: 'center',
        }}
      >
        <Pressable
          style={[styles.viewOffer]}
          onPress={() => {
            FirebaseAnalytic.trackEvent('OffersTileClicked', 'OffersView');
            NavActions.navigate(AppRoutes.Offers);
          }}
          accessibilityRole="button"
          nativeID="OffersView"
          accessibilityLabel="OffersView"
          role="button"
          aria-label="OffersView"
          testID="OffersView"
        >
          <AVText
            maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm6}
            testID="OffersView"
            adjustsFontSizeToFit={true}
          >
            {Localized.Labels.view_all}
          </AVText>
        </Pressable>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderRadius: Styles.Spacing.m2,
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: width / 2 - Styles.Heights.h2,
    aspectRatio: 1.2,
    ...getLayoutDescriber().shadowStyles().shadow,
  },
  iconView: {
    height: '44%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  offerTextView: {
    height: '28%',
    width: '100%',
    justifyContent: 'flex-start',
  },
  offerText: {
    width: '100%',
    textAlign: 'center',
    color: Styles.darkColor,
    fontSize: getLayoutDescriber().bodyLargeFontSize(),
    fontWeight: '400',
    fontFamily: Styles.FontFamily.figtreeRegular,
  },
  // viewOffer: {
  //   //left: 24,
  //   bottom: 10,
  //   borderWidth: 1,
  //   paddingHorizontal: 2,
  //   paddingVertical: 1,
  // },
  viewOffer: {
    borderTopColor: Styles.darkGreenRevolve,
    borderBottomColor: Styles.darkGreenRevolve,
    borderLeftColor: Styles.darkGreenRevolve,
    borderRightColor: Styles.darkGreenRevolve,
    borderRadius: 32,
    borderWidth: Platform.OS === 'android' ? 1.2 : 1,
    paddingVertical: 10,
    paddingHorizontal: 10,
    bottom: 10,
    overflow: 'hidden',
  },
  viewOfferbtnStyle: {
    fontWeight: Platform.OS === 'android' ? 'bold' : '600',
    fontFamily: Styles.FontFamily.figtreeRegular,
    fontSize: getLayoutDescriber().bodyFontSize(),
    color: Styles.darkGreenRevolve,
    textTransform: 'uppercase',
  },
});

export default OffersView;
